// Hides the secret menu and handles the show/hide logic for UTM parameters
function hideSecretMenu() {
  const hiddenGlobalMenu = document.querySelector('[data-hidden-menu]')?.getAttribute('data-hidden-menu');
  const hiddenCatNavMenu = document.querySelector('[data-hidden-cat-nav-menu]')?.getAttribute('data-hidden-cat-nav-menu');

  const showHiddenMenu = sessionStorage.getItem('showHiddenMenu');
  if (hiddenGlobalMenu !== null && hiddenCatNavMenu !== null) {
    [...document.querySelectorAll('.subLink')].forEach(item => {
      //covers cases where the cat nav + global nav menu items to hide have the same id
      //and when they have different ids
      if (item.id === hiddenGlobalMenu || item.id === hiddenCatNavMenu || hiddenCatNavMenu.includes(item.id)) {
        //hide cat nav item if its id is set in admin
        item.classList.add('hidden-menu');
      }
      if (showHiddenMenu) {
        //show cat nav item, if user came from correct UTM link
        item.classList.remove('hidden-menu');
      }
    });
  }
}

// Focus search field when search icon is clicked
function focusSearchField() {
  const searchIcon = document.querySelector('.search-icon');
  const searchField = document.querySelector('#search-popdown .live-search-form .live-search-form-field');

  if (searchIcon && searchField) {
    searchIcon.addEventListener('click', () => {
      searchField.focus();
    });
  }
}
document.addEventListener('DOMContentLoaded', debounce(focusSearchField));

function debounce(func, wait = 10, immediate = true) {
  let timeout;
  return function () {
    let context = this,
      args = arguments;
    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function handleFloatingFooterContent() {
  const chatWidgetSelectors = ['#gorgias-chat-container', '#gorgias-web-messenger-container', '.gorgias-chat-widget', '#attentive_creative', '#attentive_overlay'];
  const klaviyoLauncherSelectors = ['.kl-hub-launcher', '[class*="HubLauncher-floatingWidget"]'];
  const klaviyoHubOpenSelector = '.kl-hub-drawer--opened, .kl-hub-modal-veil--opened';

  function isKlaviyoHubOpen() {
    return location.hash.indexOf('k-hub') !== -1 || !!document.querySelector(klaviyoHubOpenSelector);
  }

  function setWidgetVisibility(widgets, shouldShow) {
    widgets.forEach(widget => {
      if (widget.matches('[data-floating-ui-portal]') || widget.querySelector(klaviyoHubOpenSelector)) return;
      if (shouldShow) {
        widget.style.removeProperty('display');
        return;
      }
      widget.style.setProperty('display', 'none', 'important');
    });
  }

  function setFloatingWidgetsVisibility(shouldShow) {
    chatWidgetSelectors.forEach(selector => {
      setWidgetVisibility(document.querySelectorAll(selector), shouldShow);
    });

    if (!shouldShow && isKlaviyoHubOpen()) return;

    klaviyoLauncherSelectors.forEach(selector => {
      setWidgetVisibility(document.querySelectorAll(selector), shouldShow);
    });
  }

  document.addEventListener('theme:scroll:lock', function () {
    document.dispatchEvent(new CustomEvent('chat:hide', { bubbles: true }));
  });

  document.addEventListener('theme:scroll:unlock', function () {
    document.dispatchEvent(new CustomEvent('chat:show', { bubbles: true }));
  });

  document.addEventListener('chat:hide', function () {
    setFloatingWidgetsVisibility(false);
    const cookieBanner = document.getElementById('site-cb-footer');
    if (cookieBanner) {
      cookieBanner.classList.add('hidden-bar');
    }
  });

  document.addEventListener('chat:show', function () {
    setFloatingWidgetsVisibility(true);
    const cookieBanner = document.getElementById('site-cb-footer');
    if (cookieBanner) {
      cookieBanner.classList.remove('hidden-bar');
    }
  });
}
handleFloatingFooterContent();

const floatingWidgetSelector = '.kl-hub-launcher, .kl-hub-launcher-container, [class*="HubLauncher-floatingWidget"], #gorgias-chat-container iframe#chat-button, #attentive_overlay iframe, #attentive_creative iframe';

function floatingElementClearance(element, rect = element.getBoundingClientRect()) {
  let anchor = element;
  let styles = window.getComputedStyle(anchor);
  while (anchor && styles.position !== 'fixed') {
    anchor = anchor.parentElement;
    if (anchor) styles = window.getComputedStyle(anchor);
  }

  const bottom = Number.parseFloat(styles.bottom);
  const viewportClearance = window.innerHeight - rect.top;
  if (!anchor || !Number.isFinite(bottom)) return viewportClearance;

  const hasIndividualTransform = computed => ['translate', 'rotate', 'scale'].some(property => computed[property] && computed[property] !== 'none');
  if (hasIndividualTransform(styles) || (styles.transform !== 'none' && !new DOMMatrixReadOnly(styles.transform).isIdentity)) return viewportClearance;

  // Transformed/contained ancestors make fixed offsets relative to a box, not the viewport.
  for (let parent = anchor.parentElement; parent; parent = parent.parentElement) {
    const parentStyles = window.getComputedStyle(parent);
    const createsContainingBlock = ['transform', 'perspective', 'filter', 'backdropFilter'].some(property => parentStyles[property] && parentStyles[property] !== 'none') || hasIndividualTransform(parentStyles) || /layout|paint|strict|content/.test(parentStyles.contain) || /transform|perspective|filter|translate|rotate|scale|contain/.test(parentStyles.willChange) || parentStyles.contentVisibility === 'auto';
    if (createsContainingBlock) return viewportClearance;
  }

  // Safari's scrolling viewport can move client rects without changing fixed CSS offsets.
  const inset = anchor === element ? 0 : rect.top - anchor.getBoundingClientRect().top;
  return bottom + (Number.parseFloat(styles.marginBottom) || 0) + anchor.offsetHeight - inset;
}

function floatingElementIsVisible(element, rect = element.getBoundingClientRect()) {
  const elementStyles = window.getComputedStyle(element);
  // Attentive mounts a full-viewport pass-through iframe; clearing it would push the teaser off-screen.
  if (!rect.width || !rect.height || elementStyles.visibility === 'hidden' || elementStyles.pointerEvents === 'none') return false;
  for (let ancestor = element; ancestor; ancestor = ancestor.parentElement) {
    const styles = window.getComputedStyle(ancestor);
    if (styles.display === 'none' || Number.parseFloat(styles.opacity) === 0) return false;
  }
  return true;
}

function floatingBaseClearance() {
  const sticky = document.querySelector('.sticky-atc-container');
  const cookie = document.getElementById('site-cb-footer');
  const stickyTemplate = document.querySelector('.template-product.sticky-atc-container-visible');
  const stickyRect = sticky?.getBoundingClientRect();
  const stickyShown = !!(stickyTemplate && sticky && stickyRect?.width && stickyRect?.height && sticky.style.display !== 'none' && !sticky.classList.contains('opacity-0'));
  const cookieShown = !!(cookie && cookie.style.display !== 'none' && !cookie.classList.contains('hidden-bar'));

  if (stickyShown) return { clearance: Math.max(0, floatingElementClearance(sticky, stickyRect)), source: 'sticky-atc' };
  return { clearance: cookieShown ? Math.max(0, cookie.getBoundingClientRect().height) : 0, source: cookieShown ? 'cookie' : '' };
}

function updateFloatingWidgetClearance() {
  const teasers = document.querySelectorAll('[class*="kl-teaser-"]');
  if (!teasers.length) return false;
  const floatingWidgets = document.querySelectorAll(floatingWidgetSelector);
  const { clearance, source } = floatingBaseClearance();

  teasers.forEach(teaser => {
    const teaserRect = teaser.getBoundingClientRect();
    // Preserve the last placement while hidden; reveal will refresh it before paint.
    if (!teaserRect.width || !teaserRect.height) return;
    let teaserClearance = clearance;
    // Klaviyo's teaser margin spaces it from the viewport edge; widget containers already pad themselves, so stacking keeps only one gap
    const teaserMarginBottom = Number.parseFloat(window.getComputedStyle(teaser).marginBottom) || 0;

    floatingWidgets.forEach(widget => {
      const widgetRect = widget.getBoundingClientRect();
      const widgetShown = floatingElementIsVisible(widget, widgetRect);
      const overlapsHorizontally = teaserRect.left < widgetRect.right && teaserRect.right > widgetRect.left;

      if (widgetShown && overlapsHorizontally) {
        teaserClearance = Math.max(teaserClearance, floatingElementClearance(widget, widgetRect) - teaserMarginBottom);
      }
    });

    // Klaviyo anchors corner teasers with an inline bottom; forcing bottom onto a top-anchored teaser stretches it between both edges.
    // Computed top resolves to pixels even when unset, so only Klaviyo's inline style identifies the anchor.
    const bottomAnchored = !!teaser.style.bottom && (!teaser.style.top || teaser.style.top === 'auto');
    if (!bottomAnchored || Math.round(teaserClearance) <= 0) {
      teaser.removeAttribute('data-floating-lift');
      teaser.style.removeProperty('--floating-widget-clearance');
      return;
    }
    const nextClearance = `${Math.round(teaserClearance)}px`;
    if (teaser.style.getPropertyValue('--floating-widget-clearance') !== nextClearance) teaser.style.setProperty('--floating-widget-clearance', nextClearance);
    teaser.setAttribute('data-floating-lift', source);
  });

  return [...floatingWidgets].some(widget => widget.getAnimations?.().some(animation => animation.transitionProperty === 'bottom' && animation.playState === 'running'));
}

function initKlaviyoTeaserClearance() {
  let queued = false;
  let pollTimer = 0;
  let lastScrollState = '';

  const scrollState = () => {
    const teasers = document.querySelectorAll('[class*="kl-teaser-"]');
    if (!teasers.length) return '';
    const root = document.documentElement;
    const teaserState = [...teasers].map(teaser => `${teaser.style.display}/${teaser.style.bottom}/${teaser.style.top}/${teaser.getAttribute('data-floating-lift') || ''}`).join(';');
    // Widget count catches vendors that mount after the poll without a ready event, and costs no layout read.
    return `${root.classList.contains('sticky-atc-container-visible')}|${root.style.getPropertyValue('--sticky-atc-shift')}|${document.body.classList.contains('cb-showing')}|${document.querySelectorAll(floatingWidgetSelector).length}|${teaserState}`;
  };

  const syncClearance = () => {
    const transitioning = updateFloatingWidgetClearance();
    lastScrollState = scrollState();
    return transitioning;
  };

  const recalc = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      // Keep the teaser in step until the widgets settle, even after scrolling stops.
      if (syncClearance()) recalc();
    });
  };

  // Klaviyo, Gorgias, and Attentive mount asynchronously after custom.js and klaviyoForms events.
  const startMountPoll = () => {
    recalc();
    clearInterval(pollTimer);
    let attempts = 0;
    pollTimer = setInterval(() => {
      attempts += 1;
      recalc();
      if (attempts >= 15) clearInterval(pollTimer);
    }, 400);
  };

  document.addEventListener('chat:hide', recalc);
  document.addEventListener('chat:show', recalc);
  document.addEventListener('cookie-bar:change', recalc);
  document.addEventListener('theme:resize', recalc);
  // The theme scroll event already runs in an animation frame; skip layout reads when sticky and teaser state are unchanged.
  document.addEventListener('theme:scroll', () => {
    if (queued) return;
    const nextState = scrollState();
    if (nextState === lastScrollState) return;
    if (syncClearance()) recalc();
  });
  window.addEventListener('klaviyoForms', startMountPoll);
  window.addEventListener('gorgias-widget-loaded', startMountPoll);
  // App embeds like Attentive have no ready event and usually inject after load, past the initial poll window.
  if (document.readyState !== 'complete') window.addEventListener('load', startMountPoll, { once: true });
  document.addEventListener('animationend', event => {
    if (event.target.closest?.('[class*="kl-teaser-"]')) recalc();
  });
  ['transitionrun', 'transitionend', 'transitioncancel'].forEach(eventName => {
    document.addEventListener(eventName, event => {
      if (event.propertyName === 'bottom' && event.target.matches?.(floatingWidgetSelector)) recalc();
    });
  });

  startMountPoll();
}

initKlaviyoTeaserClearance();

function hideFloatingWidgetsOverFullPagePromos() {
  const overlayClass = 'fullpage-promo-open';
  const overlaySelectors = ['#attentive_overlay iframe', '#attentive_creative iframe', '[data-testid="klaviyo-form-View"]', '.klaviyo-form iframe', '[class*="kl-private-reset-css"]'];
  let overlayOpen = false;

  function isThemeFloatingWidget(el) {
    return !!(el.closest('#gorgias-chat-container') || el.closest('.kl-hub-launcher-container') || el.closest('[class*="HubLauncher-floatingWidget"]') || el.closest('[data-floating-ui-portal]') || el.closest('button.kl-hub-launcher'));
  }

  function overlayCoversPage() {
    const minWidth = window.innerWidth * 0.75;
    const minHeight = window.innerHeight * 0.5;
    return overlaySelectors.some(selector =>
      [...document.querySelectorAll(selector)].some(el => {
        if (isThemeFloatingWidget(el)) return false;
        const rect = el.getBoundingClientRect();
        if (rect.width < minWidth || rect.height < minHeight) return false;
        if (rect.bottom <= 0 || rect.right <= 0 || rect.top >= window.innerHeight || rect.left >= window.innerWidth) return false;
        const style = window.getComputedStyle(el);
        // pointer-events: none means a pass-through wrapper (e.g. Attentive's full-viewport badge iframe), not a real popup
        if (style.display === 'none' || style.visibility === 'hidden' || style.pointerEvents === 'none' || Number(style.opacity) === 0) return false;
        if (el.getAttribute('aria-hidden') === 'true') return false;
        let ancestor = el.parentElement;
        while (ancestor && ancestor !== document.documentElement) {
          const ancestorStyle = window.getComputedStyle(ancestor);
          if (ancestorStyle.display === 'none' || ancestorStyle.visibility === 'hidden' || Number(ancestorStyle.opacity) === 0) return false;
          ancestor = ancestor.parentElement;
        }
        return true;
      })
    );
  }

  function hasOverlayCandidate() {
    return overlaySelectors.some(selector => document.querySelector(selector));
  }

  function syncOverlayWidgets() {
    if (!hasOverlayCandidate()) {
      if (!overlayOpen) return;
      overlayOpen = false;
      document.documentElement.classList.remove(overlayClass);
      updateFloatingWidgetClearance();
      return;
    }
    const shouldHide = overlayCoversPage();
    if (shouldHide === overlayOpen) return;
    overlayOpen = shouldHide;
    document.documentElement.classList.toggle(overlayClass, shouldHide);
    updateFloatingWidgetClearance();
  }

  document.addEventListener('theme:resize:width', syncOverlayWidgets);
  document.addEventListener('theme:scroll', syncOverlayWidgets);
  setInterval(syncOverlayWidgets, 400);
  syncOverlayWidgets();
}
hideFloatingWidgetsOverFullPagePromos();

function handleKlaviyoHeartOnCartOpen() {
  const klaviyoSelector = '[data-floating-ui-portal]';
  let klaviyoElement = null;
  let retryTimeout;

  function findKlaviyoElement() {
    const element = document.querySelector(klaviyoSelector);
    if (element && !element.closest('[data-drawer="drawer-cart"]')) {
      klaviyoElement = element;
      return element;
    }
    return null;
  }

  function toggleKlaviyoVisibility(show) {
    const element = findKlaviyoElement();
    if (element) {
      element.style.display = show ? '' : 'none';
      clearTimeout(retryTimeout);
      return true;
    }
    return false;
  }

  function retryToggle(show, attempt = 1) {
    if (toggleKlaviyoVisibility(show) || attempt >= 10) return;
    retryTimeout = setTimeout(() => retryToggle(show, attempt + 1), 200);
  }

  function handleDrawerOpen() {
    klaviyoElement = null;
    if (!toggleKlaviyoVisibility(false)) {
      retryToggle(false);
    }
  }

  function handleDrawerClose() {
    klaviyoElement = null;
    if (!toggleKlaviyoVisibility(true)) {
      retryToggle(true);
    }
  }

  function init() {
    const cartDrawer = document.getElementById('drawer-cart');
    if (cartDrawer) {
      cartDrawer.addEventListener('theme:drawer:open', handleDrawerOpen);
      cartDrawer.addEventListener('theme:drawer:close', handleDrawerClose);
      return true;
    }
    return false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (!init()) setTimeout(init, 100);
    });
  } else {
    if (!init()) setTimeout(init, 100);
  }
}
handleKlaviyoHeartOnCartOpen();

// Mobile hamburger nav rework: keep the site header visible while the menu is
// open, drive the L1 back arrow, and hand off to the cart/search overlays.
// Scroll locking is owned by the shared theme:scroll:lock / theme:scroll:unlock
// path (overflow lock on the drawer inner, which preserves scroll position).
function handleHamburgerNav() {
  const getHamburgerDrawer = () => document.querySelector('.header__drawer[data-drawer="hamburger"]');

  // Drilled category name shown centered in the persistent header (Figma
  // "NavOpen_L1-top"). The stack mirrors the open sliderule panes so back/close
  // reveal the parent title; CSS only shows it while hamburger-nav-drilled.
  const titleStack = [];
  const renderTitle = () => {
    const el = document.querySelector('[data-hamburger-title]');
    if (el) el.textContent = titleStack[titleStack.length - 1] || '';
  };

  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-sliderule-open]');
    if (!opener) return;
    const title = opener.querySelector('.sliderow__title');
    titleStack.push(title ? title.textContent.trim() : '');
    renderTitle();
  });

  document.addEventListener('theme:sliderule:close', () => {
    titleStack.length = 0;
    renderTitle();
  });

  // Back arrow in the persistent header steps back one drilled level by
  // triggering the deepest open sliderule panel's own close control.
  document.addEventListener('click', e => {
    const back = e.target.closest('[data-hamburger-back]');
    if (!back) return;
    e.preventDefault();
    const drawer = getHamburgerDrawer();
    if (!drawer) return;
    const visible = drawer.querySelectorAll('[data-sliderule].is-visible');
    if (!visible.length) return;

    let deepest = null;
    let maxDepth = -1;
    visible.forEach(panel => {
      let depth = 0;
      let node = panel.parentElement;
      while (node) {
        if (node.matches && node.matches('[data-sliderule]')) depth++;
        node = node.parentElement;
      }
      if (depth > maxDepth) {
        maxDepth = depth;
        deepest = panel;
      }
    });

    // Only step the header title back if a level actually closed, so a missing
    // control cannot leave the title ahead of the visible panel.
    const closeBtn = deepest && deepest.querySelector(`[data-sliderule-close="${deepest.id}"]`);
    if (!closeBtn) return;
    closeBtn.click();
    titleStack.pop();
    renderTitle();
  });

  // Tapping bag or search while the nav is open should reveal that overlay on
  // top first, then slide the nav closed underneath a beat later (without
  // releasing the shared scroll lock, which the overlay now owns).
  let pendingNavClose = 0;

  const closeNavNow = () => {
    pendingNavClose = 0;
    const drawer = getHamburgerDrawer();
    if (!drawer || !drawer.classList.contains('drawer--visible')) return;
    drawer.dispatchEvent(new CustomEvent('theme:drawer:close:silent', { bubbles: false }));
  };

  // Capture phase: each overlay's own toggle listener sits on the trigger, so
  // this has to run ahead of it to mark the search panel before it starts
  // animating, and to read aria-expanded while it still describes the state
  // before the click.
  document.addEventListener(
    'click',
    e => {
      const trigger = e.target.closest('[data-drawer-toggle="drawer-cart"], [data-popdown-toggle="search-popdown-mobile"]');
      if (!trigger) return;
      const drawer = getHamburgerDrawer();
      const navOpen = Boolean(drawer) && drawer.classList.contains('drawer--visible');

      // Recomputed on every search open so the drop-from-header animation is
      // limited to this handoff and a normal open keeps its side slide. The
      // reflow renders the new resting transform before the overlay's own
      // listener adds .is-visible, otherwise the panel would animate from
      // whichever edge it was last painted at.
      const popdownId = trigger.getAttribute('data-popdown-toggle');
      const popdown = popdownId ? document.getElementById(popdownId) : null;
      if (popdown && popdown.classList.contains('search-popdown-mobile--from-nav') !== navOpen) {
        popdown.classList.toggle('search-popdown-mobile--from-nav', navOpen);
        void popdown.offsetWidth;
      }

      if (!navOpen) return;

      // A bag tap while the cart is already open toggles it shut and releases
      // the shared scroll lock, so there is no incoming overlay to wait for:
      // drop the nav now rather than leave it over a page that can scroll.
      const closingCart = trigger.matches('[data-drawer-toggle="drawer-cart"]') && trigger.getAttribute('aria-expanded') === 'true';
      if (closingCart) {
        clearTimeout(pendingNavClose);
        closeNavNow();
        return;
      }

      clearTimeout(pendingNavClose);
      pendingNavClose = setTimeout(closeNavNow, 250);
    },
    true
  );

  // The overlay holds the shared scroll lock for the length of the handoff, so
  // closing it before the nav has slid out (Escape, outside click, its own close
  // control) unlocks the page with the menu still up. Listening on document puts
  // this ahead of the window-level unlock handler, so the nav is already on its
  // way out before the page can move.
  document.addEventListener('theme:scroll:unlock', () => {
    if (!pendingNavClose) return;
    clearTimeout(pendingNavClose);
    closeNavNow();
  });
}
handleHamburgerNav();

// Portal global overlays out of their parent sections into #theme-overlays so
// they are not capped by a section's stacking context (paired with the
// `.shopify-section { isolation: isolate; }` rule in theme.css.liquid).
//
// The portal must run AFTER each section's onLoad has constructed its Drawer
// instances and any other handlers that querySelector inside the section
// container. Once those handlers hold a reference to the element, moving the
// node elsewhere in the DOM does not break their bound listeners. We run on
// `window.load` (after DOMContentLoaded and section init) to be safe.
function portalThemeOverlays() {
  function portal(selector) {
    const overlays = document.getElementById('theme-overlays');
    const node = document.querySelector(selector);
    if (!overlays || !node || node.parentElement === overlays) return;
    overlays.appendChild(node);
  }

  // A re-rendered section creates a fresh node with the same id while the
  // previously portaled copy still lives in #theme-overlays; drop the stale
  // copy before moving the fresh node so we never leave duplicate ids behind.
  function portalById(selector) {
    const overlays = document.getElementById('theme-overlays');
    if (!overlays) return;
    document.querySelectorAll(selector).forEach(node => {
      if (node.parentElement === overlays) return;
      if (node.id) overlays.querySelectorAll(`#${CSS.escape(node.id)}`).forEach(stale => stale.remove());
      overlays.appendChild(node);
    });
  }

  function moveAll() {
    portal('[data-drawer="drawer-cart"]');
    portal('.header__drawer[data-drawer="hamburger"]');
    portalById('#vue-zoom-wrapper');
    portalById('#sticky-PDPaddtocart'); // mobile sticky ATC — escapes section isolation
  }

  // Defer to the next frame so the re-rendered section's own onLoad has re-bound
  // its handlers to the fresh nodes before we move them out of the section.
  function schedule() {
    requestAnimationFrame(moveAll);
  }

  if (document.readyState === 'complete') {
    moveAll();
  } else {
    window.addEventListener('load', moveAll, { once: true });
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('pdp:section:updated', schedule);
}
portalThemeOverlays();

(function () {
  // check if the secret menu content exists and handle the show/hide logic
  const secretMenuContent = document.querySelector('[data-hidden-menu]');
  if (secretMenuContent !== null) {
    secretMenuContent.addEventListener('DOMContentLoaded', hideSecretMenu());
  }
})();

function handleVideoHero() {
  const videoConfigs = [
    {
      containerSelector: '.mp4-container',
      playButtonClass: '.play-button',
      pauseButtonClass: '.pause-button',
      videoClass: '.video-hero'
    },
    {
      containerSelector: '.mp4-container-mobile',
      playButtonClass: '.play-button-mobile',
      pauseButtonClass: '.pause-button-mobile',
      videoClass: '.video-hero-mobile'
    }
  ];

  videoConfigs.forEach(cfg => {
    document.querySelectorAll(cfg.containerSelector).forEach(section => {
      const playButton = section.querySelector(cfg.playButtonClass);
      const pauseButton = section.querySelector(cfg.pauseButtonClass);
      // Shopify's video_tag does not reliably apply its class parameter, so the class
      // selector can miss a video that is present. Without this fallback the controls
      // silently never bind.
      const video = section.querySelector(cfg.videoClass) || section.querySelector('video');

      if (!playButton || !pauseButton || !video) return;

      function setupControls() {
        playButton.onclick = function () {
          video.play();
          pauseButton.classList.remove('is-hidden');
          playButton.classList.add('is-hidden');
          pauseButton.focus();
        };
        pauseButton.onclick = function () {
          video.pause();
          pauseButton.classList.add('is-hidden');
          playButton.classList.remove('is-hidden');
          playButton.focus();
        };
      }

      if (video.readyState >= 3) {
        setupControls();
      } else {
        video.addEventListener('loadeddata', setupControls, { once: true });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', debounce(handleVideoHero));

/**
 * Section Double Height Manager (Advanced)
 * Enhanced height management for section-double.liquid with PDP refresh functionality
 */
(function () {
  'use strict';

  const initializedSections = new WeakSet();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  function initAllSections() {
    const sectionElements = document.querySelectorAll('[data-section-type="custom-content"]');
    sectionElements.forEach(sectionEl => {
      if (sectionEl.querySelector('[data-overflow-wrapper]')) {
        initSectionHeightManager(sectionEl);
      }
    });
  }

  function initSectionHeightManager(thisSectionEl) {
    if (initializedSections.has(thisSectionEl)) {
      return;
    }

    initializedSections.add(thisSectionEl);

    const thisSectionId = thisSectionEl.id;
    if (!thisSectionEl) {
      console.warn(`[section-double] Section element not found: ${thisSectionId}`);
      return;
    }

    const isMobileDevice = () => {
      return window.siteGlobals?.device === 'mobile-size' || document.body?.classList.contains('mobile-size') || window.innerWidth <= (window.layoutMobileMaxWidth || 767);
    };

    const configScript = thisSectionEl.querySelector('[data-section-refresh-config]');
    let sectionId = thisSectionId;
    let desktopHeight = thisSectionEl.dataset.desktopHeight ? parseInt(thisSectionEl.dataset.desktopHeight) : null;
    let mobileHeight = thisSectionEl.dataset.mobileHeight ? parseInt(thisSectionEl.dataset.mobileHeight) : null;

    if (configScript) {
      try {
        const cfg = JSON.parse(configScript.textContent);
        sectionId = cfg.sectionId || thisSectionId;
        desktopHeight = cfg.desktopHeight || desktopHeight;
        mobileHeight = cfg.mobileHeight || mobileHeight;
      } catch (parseError) {
        console.error('[section-double] Failed to parse config:', parseError);
      }
    }

    function computeTokenHeight(sectionElement) {
      const wrapper = sectionElement.querySelector('[data-overflow-wrapper]');
      if (!wrapper) return 0;

      const isMobile = isMobileDevice();
      const tokenAttr = isMobile ? wrapper.getAttribute('data-height-mobile') || '' : wrapper.getAttribute('data-height-desktop') || '';
      const classToken = Array.from(wrapper.classList || []).find(c => c.indexOf('use_') === 0) || '';
      const token = tokenAttr || classToken;
      if (!token) return 0;

      const viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
      const t = token.replace('use_', '');
      const px = t.match(/^pixels_(\d{2,4})$/);
      if (px) return parseInt(px[1]);

      switch (t) {
        case 'screen_full':
          return viewportH;
        case 'screen_three_quarters':
          return Math.round(viewportH * 0.75);
        case 'screen_two_thirds':
          return Math.round((viewportH * 2) / 3);
        case 'screen_one_half':
          return Math.round(viewportH * 0.5);
        case 'screen_one_third':
          return Math.round(viewportH / 3);
        case 'screen_one_fifth':
          return Math.round(viewportH / 5);
        case 'image':
        default:
          return 0;
      }
    }

    function applyHeightOverrides() {
      const sectionElement = document.getElementById(sectionId) || thisSectionEl;
      if (!sectionElement) {
        console.warn('[section-double] Section element not found during height override');
        return;
      }

      const wrappers = sectionElement.querySelectorAll('[data-overflow-wrapper]');
      if (!wrappers.length) {
        return;
      }

      const isMobile = isMobileDevice();
      let currentDesktopHeight = desktopHeight;
      let currentMobileHeight = mobileHeight;

      const refreshedConfigScript = sectionElement.querySelector('[data-section-refresh-config]');
      if (refreshedConfigScript) {
        try {
          const refreshedCfg = JSON.parse(refreshedConfigScript.textContent);
          currentDesktopHeight = refreshedCfg.desktopHeight || desktopHeight;
          currentMobileHeight = refreshedCfg.mobileHeight || mobileHeight;
        } catch (e) {
          console.error('[section-double] Failed to parse refreshed config:', e);
        }
      }

      let targetHeight = isMobile ? currentMobileHeight : currentDesktopHeight;
      let maxHeightDesktopStr = '';
      let maxHeightMobileStr = '';

      if (wrappers.length > 0) {
        maxHeightDesktopStr = wrappers[0].getAttribute('data-max-height-desktop') || '';
        maxHeightMobileStr = wrappers[0].getAttribute('data-max-height-mobile') || '';
      }

      const maxHeightDesktop = maxHeightDesktopStr && maxHeightDesktopStr !== '' ? parseInt(maxHeightDesktopStr) || 0 : 0;
      const maxHeightMobile = maxHeightMobileStr && maxHeightMobileStr !== '' ? parseInt(maxHeightMobileStr) || 0 : 0;
      const hasMaxHeight = (isMobile && maxHeightMobile > 0) || (!isMobile && maxHeightDesktop > 0);

      if (hasMaxHeight && (!targetHeight || targetHeight <= 0)) {
        wrappers.forEach(wrapper => {
          if (wrapper && wrapper.style) {
            wrapper.style.removeProperty('height');
            wrapper.style.removeProperty('overflow');
          }
        });
        return;
      }

      if (!targetHeight || targetHeight <= 0) {
        targetHeight = computeTokenHeight(sectionElement);
      }

      if (!targetHeight || targetHeight <= 0 || targetHeight > 5000) return;

      wrappers.forEach(wrapper => {
        if (wrapper && wrapper.style) {
          if (hasMaxHeight) {
            wrapper.style.removeProperty('height');
            wrapper.style.removeProperty('overflow');
            const blocks = wrapper.querySelectorAll('.brick__block');
            blocks.forEach(block => {
              if (block && block.style) {
                block.style.removeProperty('height');
                block.style.removeProperty('min-height');
                block.style.removeProperty('overflow');
              }
            });
          } else if (!isMobile) {
            wrapper.style.setProperty('height', targetHeight + 'px', 'important');
            wrapper.style.setProperty('overflow', 'hidden', 'important');
          } else {
            wrapper.style.removeProperty('height');
            wrapper.style.removeProperty('overflow');
            const blocks = wrapper.querySelectorAll('.brick__block');
            blocks.forEach(block => {
              if (block && block.style) {
                block.style.setProperty('height', targetHeight + 'px', 'important');
                block.style.setProperty('min-height', targetHeight + 'px', 'important');
                block.style.setProperty('overflow', 'hidden', 'important');
              }
            });
          }
        }
        if (!hasMaxHeight) {
          const frames = wrapper.querySelectorAll('[data-overflow-frame], [data-overflow-background]');
          frames.forEach(el => {
            if (el && el.style && !el.closest('.overlapping-block')) {
              el.style.setProperty('min-height', Math.max(targetHeight - 2, 0) + 'px', 'important');
            }
          });
        }
      });
    }

    let resizeTimeout;
    const debouncedApply = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        applyHeightOverrides();
        if (window.AOS && window.theme?.settings?.animate_scroll) {
          window.AOS.refresh();
        }
      }, 100);
    };

    const handleSectionLoad = e => {
      if (e && e.target && e.target.id === thisSectionId) {
        debouncedApply();
      }
    };

    const handleSectionUpdated = e => {
      if (e.detail && e.detail.sectionId === thisSectionId) {
        const retryHeightApplication = (attempt = 1, maxAttempts = 5) => {
          const delay = attempt * 100;
          setTimeout(() => {
            const sectionElement = document.getElementById(thisSectionId);
            const wrappers = sectionElement ? sectionElement.querySelectorAll('[data-overflow-wrapper]') : [];
            if (wrappers.length > 0) {
              debouncedApply();
            } else if (attempt < maxAttempts) {
              retryHeightApplication(attempt + 1, maxAttempts);
            } else {
              console.warn('[section-double] Failed to find wrappers after ' + maxAttempts + ' attempts');
            }
          }, delay);
        };
        retryHeightApplication();
      }
    };

    const handleSectionSelect = e => {
      if (e && e.target && e.target.id === thisSectionId) {
        debouncedApply();
      }
    };

    const handleBeforeUnload = () => {
      clearTimeout(resizeTimeout);
    };

    const cleanup = () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener('resize', debouncedApply);
      document.removeEventListener('theme:resize', debouncedApply);
      document.removeEventListener('shopify:section:load', handleSectionLoad);
      document.removeEventListener('pdp:section:updated', handleSectionUpdated);
      document.removeEventListener('shopify:section:select', handleSectionSelect);
      document.removeEventListener('load', debouncedApply, true);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      initializedSections.delete(thisSectionEl);
    };

    applyHeightOverrides();

    window.addEventListener('resize', debouncedApply);
    document.addEventListener('theme:resize', debouncedApply);
    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('pdp:section:updated', handleSectionUpdated);
    document.addEventListener('shopify:section:select', handleSectionSelect);
    document.addEventListener('load', debouncedApply, true);
    window.addEventListener('beforeunload', handleBeforeUnload);

    document.addEventListener('shopify:section:unload', e => {
      if (e && e.target && e.target.id === thisSectionId) {
        cleanup();
      }
    });
  }
})();
